<template>
  <div
    class="recommend-history"
    v-infinite-scroll="loadMore"
    infinite-scroll-disabled="scrollDisabled"
    infinite-scroll-immediate-check="false">
      <div class="history-top">
        <p>历史奖励免单卡数（张）</p>
        <p class="count">{{freeCardTotal || 0}}</p>
      </div>
      <div class="history-list-box">
        <p class="title">历史邀请记录</p>
        <div class="history-table">
          <div class="table-head">
            <p class="w-head">期数</p>
            <p class="w-head2">推荐人数</p>
            <p class="grow1">排名</p>
            <p class="w-last">奖励</p>
          </div>
          <div class="table-body">
            <div class="table-item" v-for="(item, index) in dataList" :key="index">
              <p class="w-head"><span :class="{'badge-btn': item.IsLastCycle}">{{item.Cycle}}</span></p>
              <p class="w-head2">{{item.RecommendCount || 0}}人</p>
              <p class="grow1"><span :class="{
                'rank-btn': true,
                'active': item.RecommendRank && item.RecommendRank  <= 3
                }">NO.{{item.RecommendRank || '-'}}</span>
              </p>
              <p class="w-last blod">{{item.AwardFreeCardNum ? `${item.AwardFreeCardNum}张` : '无'}}</p>
            </div>
          </div>
        </div>
        <div class="table-no" v-if="!haveMore">没有更多记录了</div>
      </div>
  </div>
</template>

<script>
import { RecommendHistoryList } from '@/api/recommendRank'
import { Indicator, Toast } from 'mint-ui'

export default {
  name: 'RecommendHistory',
  data () {
    return {
      haveMore: true,
      scrollDisabled: false,
      freeCardTotal: 0,
      dataList: [],
      currentPage: 1,
      page: 1,
      pageCount: 1
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let params = {
        page: this.currentPage,
        rows: 10
      }
      this.scrollDisabled = true
      RecommendHistoryList(params).then(res => {
        this.scrollDisabled = false
        if (res.FreeCardTotal) this.freeCardTotal = res.FreeCardTotal
        this.dataList = [...this.dataList, ...res.DataList]
        this.page = res.PaginationViewModel.Page
        this.pageCount = res.PaginationViewModel.PageCount
        if (res.PaginationViewModel.Page >= res.PaginationViewModel.PageCount) {
          this.haveMore = false
        } else {
          this.haveMore = true
        }
        Indicator.close()
      }).catch(err => {
        Indicator.close()
        Toast(err.ErrMsg)
      })
    },
    // 加载更多
    loadMore () {
      let { page, pageCount } = this
      if (page >= pageCount) {
        this.haveMore = false
        return
      }
      this.currentPage += 1
      this.haveMore = true
      this.fetchData()
    }
  }
}
</script>

<style>
  .recommend-history{
    height: 100vh;
    background: #f2f2f2;
    box-sizing: border-box;
    padding: 2% 2%;
    overflow-x: hidden;
    overflow-y: scroll;
    font-size: 14px;
  }
  .history-top{
    background: #fff;
    border-radius: 10px;
    height: 16vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .history-top .count{
    font-size: 30px;
    color: #60c781;
  }
  .history-list-box{
    background: #fff;
    border-radius: 10px;
    margin-top: 10px;
    overflow: hidden;
  }
  .history-list-box .title{
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    margin-top: 10px;
  }
  /* table */
  .history-table{
    margin-top: 5px;
  }
  .history-table .w-head{
    text-align: center;
    width: 100px;
    border-right: 1px solid #eee;
    flex-shrink: 0;
  }
  .history-table .w-head2{
    text-align: center;
    width: 80px;
    flex-shrink: 0;
  }
  .history-table .w-last{
    text-align: center;
    width: 80px;
    flex-shrink: 0;
  }
  .table-head{
    display: flex;
    align-items: center;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }
  .table-head > p{
    height: 40px;
    line-height: 40px;
  }
  .history-table .grow1{
    flex-grow: 1;
    text-align: center;
    box-sizing: border-box;
  }
  .table-item{
    height: 70px;
    line-height: 70px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
  }
  .table-item .badge-btn{
    display: inline-block;
    background: #60c781;
    color: #fff;
    height: 30px;
    line-height: 30px;
    border-radius: 12px;
    padding: 0 8px;
  }
  .table-item .rank-btn{
    background: #ababab;
    color: #fff;
    border-radius: 3px;
    font-size: 13px;
    padding: 0 5px;
  }
  .table-item .rank-btn.active{
    background: #f23030;
  }
  .table-item .blod{
    font-weight: 600;
  }
  .table-no{
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #999;
  }
  @media screen and (max-width: 320px){
    .history-table .w-last{
      width: 60px;
    }
  }
</style>
